import * as React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as DeliveredIcon,
  Schedule as PendingIcon,
  Send as SentIcon,
  Error as FailedIcon,
} from '@mui/icons-material';
import { withTranslation } from 'react-i18next';

const statusConfig = {
  pending: {
    color: '#92400e',
    bgcolor: '#fef3c7',
    borderColor: '#fcd34d',
    icon: PendingIcon,
  },
  sent: {
    color: '#1e40af',
    bgcolor: '#dbeafe',
    borderColor: '#93c5fd',
    icon: SentIcon,
  },
  delivered: {
    color: '#065f46',
    bgcolor: '#d1fae5',
    borderColor: '#6ee7b7',
    icon: DeliveredIcon,
  },
  failed: {
    color: '#991b1b',
    bgcolor: '#fee2e2',
    borderColor: '#fca5a5',
    icon: FailedIcon,
  },
};

const MaventaStatusBadge = ({ status, deliveryMethod, errorMessage, t, size = 'small' }) => {
  // Don't render if no maventa status
  if (!status || status === '') {
    return null;
  }

  const config = statusConfig[status] || statusConfig.pending;
  const IconComponent = config.icon;

  const getDeliveryLabel = () => {
    switch (deliveryMethod) {
      case 'verkkolasku':
        return t('deliveryType.verkkolasku', 'Verkkolasku');
      case 'email_maventa':
        return t('deliveryType.emailMaventa', 'Sähköposti');
      case 'paper_priority':
        return t('deliveryType.paperPriority', 'Kirjelasku');
      case 'paper_economy':
        return t('deliveryType.paperEconomy', 'Kirjelasku');
      default:
        return t('deliveryType.invoice', 'Lasku');
    }
  };

  const getLabel = () => {
    const label = getDeliveryLabel();
    switch (status) {
      case 'pending':
        return t('delivery.status.pending', '{{label}} käsittelyssä', { label });
      case 'sent':
        return t('delivery.status.sent', '{{label}} lähetetty', { label });
      case 'delivered':
        return t('delivery.status.delivered', '{{label}} toimitettu', { label });
      case 'failed':
        return t('delivery.status.failed', '{{label}} epäonnistui', { label });
      default:
        return status;
    }
  };

  const chip = (
    <Chip
      label={getLabel()}
      size={size}
      icon={<IconComponent sx={{ fontSize: size === 'small' ? '14px' : '16px' }} />}
      sx={{
        color: config.color,
        bgcolor: config.bgcolor,
        border: `1px solid ${config.borderColor}`,
        fontWeight: 500,
        fontSize: size === 'small' ? '11px' : '12px',
        height: size === 'small' ? '22px' : '26px',
        '& .MuiChip-label': {
          px: 0.75,
        },
        '& .MuiChip-icon': {
          color: config.color,
          marginLeft: '6px',
        },
      }}
    />
  );

  // Show tooltip with error message if failed
  if (status === 'failed' && errorMessage) {
    return (
      <Tooltip title={errorMessage} placement="top">
        {chip}
      </Tooltip>
    );
  }

  return chip;
};

export default withTranslation()(MaventaStatusBadge);
